module.exports = __webpack_public_path__ + "img/appAsset-Branding--TemplateEmail-modern.12b44ad4.svg";